import React from 'react';
// import { Divider } from 'semantic-ui-react'

const HomeRtes1 = ({autorizacUA, styles, handleClickSel1, handleClickSel2, handleClickSel3,
                    handleClickSel4, handleClickSel5, handleClickSel6}) => {
  const a1501 = autorizacUA.findIndex( autorizac => autorizac === "1501" );
  const a1505 = autorizacUA.findIndex( autorizac => autorizac === "1505" );
  const a1510 = autorizacUA.findIndex( autorizac => autorizac === "1510" );
  const a1515 = autorizacUA.findIndex( autorizac => autorizac === "1515" );
  const a1520 = autorizacUA.findIndex( autorizac => autorizac === "1520" );
  const a1525 = autorizacUA.findIndex( autorizac => autorizac === "1525" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        REPORTES
      </button>

      {a1501!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large address card outline violet icon"></i>
        Clientes
      </button>
      }
      {a1505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large money bill alternate outline violet icon"></i>
        Recaudo
      </button>
      }
      {a1510!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
        <i className="large clipboard list violet icon"></i>
        Ordenes de servicio
      </button>
      }
      {a1515!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
      {/* <button className="ui labeled icon button fluid" style={styles.dropdown}> */}
        <i className="large newspaper outline violet icon"></i>
        Facturación
      </button>
      }
      {a1520!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel5}>
        <i className="large id badge violet icon"></i>
        Gestión terceros
      </button>
      }
      {a1525!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel6}>
        <i className="large id badge violet icon"></i>
        Notas / Ajustes
      </button>
      }

    </div>
  )
};

export default HomeRtes1
